import * as classNames from 'classnames'
import * as React from 'react'

import * as styles from './index.module.css'

import ChevronUpIcon from '../../../../shared/components/icons/chevronUp'

interface IProps {
  children: React.ReactNode
  id: string
  title: string
  expanded?: boolean
  togglePanel?: any
}

const ExpandingFilterPanel = ({
  children,
  id,
  title,
  expanded,
  togglePanel
}: IProps) => {
  const toggleButtonStyle = classNames({
    [styles.buttonToggle]: true,
    [styles.buttonToggleActive]: expanded
  }) as any

  return (
    <div className={styles.filterContainer} data-test-selector={`filter-${id}`}>
      <button
        className={toggleButtonStyle}
        onClick={togglePanel.bind(undefined, id)}
        type="button"
        aria-label={`Click to ${expanded ? 'collapse' : 'expand'}`}
      >
        <div className={styles.headingContainer}>
          <h3 className={styles.heading}>{title}</h3>
          <ChevronUpIcon width="13" height="8" />
        </div>
      </button>
      {expanded ? children : null}
    </div>
  )
}

export default ExpandingFilterPanel
